export const initCatalogFilter = () => {
    const checkboxes = document.querySelectorAll('.catalogue-filter input[id^="supplier_"]');
    const supplierRows = document.querySelectorAll('.catalogue-supplier-group.row[data-supplier-id]');

    function filterCatalogues() {
        const checkedSuppliers = Array.from(checkboxes)
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.id.replace('supplier_', ''));

        supplierRows.forEach(row => {
            const supplierId = row.getAttribute('data-supplier-id');
            
            if (checkedSuppliers.length === 0 || checkedSuppliers.includes(supplierId)) {
                row.classList.remove('d-none');
                row.classList.add('d-flex');
            } else {
                row.classList.remove('d-flex');
                row.classList.add('d-none');
            }
        });
    }

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', filterCatalogues);
    });
}